import { apiForPrivate } from '.';
import { INCIDENT_ENDPOINT } from '../../config/ap';

const apiIncidents = apiForPrivate.injectEndpoints({

    overrideExisting: true,
    
    endpoints: build => ({
        getLatestIncidents: build.query({
            query: () => ({
                url: `${INCIDENT_ENDPOINT.INCIDENTS}/latest`,
            })
        }),
        getUnmappedIncidents: build.query({
            query: (days?: number) => ({
                url: `${INCIDENT_ENDPOINT.INCIDENTS}/unmapped`,
                params: days ? { days } : undefined,
            })
        })
    })
});

export const {
    useGetLatestIncidentsQuery,
    useGetUnmappedIncidentsQuery,
} = apiIncidents;